import { useResource } from "@/admin/useResource";
import {
  PageHeader,
  ResourceView,
  StatusBadge,
  money,
  fmtDate,
} from "@/admin/adminComponents";

const STATUS_OPTIONS = [
  { value: "unpaid", label: "Unpaid" },
  { value: "processing", label: "Processing" },
  { value: "paid", label: "Paid" },
];

const columns = [
  { key: "id", label: "ID", render: (r) => <span className="font-mono text-xs">{r.id}</span> },
  { key: "restaurant_name", label: "Restaurant", render: (r) => <span className="font-medium text-halalgo-ink">{r.restaurant_name}</span> },
  { key: "amount_due", label: "Amount Due", render: (r) => <span className="font-semibold">{money(r.amount_due, r.currency)}</span> },
  { key: "period", label: "Period", render: (r) => <span className="whitespace-nowrap">{r.period}</span> },
  { key: "statement_date", label: "Statement Date", render: (r) => <span className="whitespace-nowrap text-xs">{fmtDate(r.statement_date)}</span> },
  { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
];

export default function Settlements() {
  const { data, mocked, loading, refreshing, reload } = useResource("/settlements", "settlements");
  return (
    <div data-testid="admin-settlements-page">
      <PageHeader title="Settlements" subtitle="Payouts owed to partner restaurants." mocked={mocked} />
      <ResourceView
        columns={columns}
        rows={data}
        loading={loading}
        testId="settlements-table"
        exportName="settlements"
        onRefresh={reload}
        refreshing={refreshing}
        searchPlaceholder="Search by restaurant, period..."
        searchKeys={["id", "restaurant_name", "period"]}
        filter={{ key: "status", placeholder: "Filter by status", allLabel: "All statuses", options: STATUS_OPTIONS }}
        dateFilter={{ key: "statement_date", label: "Statement date" }}
        detailTitle={(r) => r.restaurant_name}
        detailSubtitle={(r) => `${money(r.amount_due, r.currency)} \u2022 ${r.period}`}
      />
    </div>
  );
}
